"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'AnalyticsScriptUrl': '#{AnalyticsScriptUrl}',
    'AppshellUrl': '#{AppshellUrl}',
    'AuthorizeTrustpilotApiHosts': '#{AuthorizeTrustpilotApiHosts}',
    'BusinessAppAuthenticationApi.Host': '#{BusinessAppAuthenticationApi.Host}',
    'BusinessAppUrl': '#{BusinessAppUrl}/',
    'BusinessAuthentication.ClientId': '#{BusinessAuthentication.ClientId}',
    'BusinessAuthentication.Host': '#{BusinessAuthentication.Host}',
    'CookieDomain': '#{CookieDomain}',
    'Domain': '#{Domain}',
    'Environment': '#{Environment}',
    'launchDarklyKey': '#{launchDarklyKey}',
    'mainViewPage': 'views/b2b-template-standard.html',
    'oneTrustScript': '#{OneTrustScript}',
    'PolyfillsScriptUrl': '#{PolyfillsScriptUrl}',
    'SegmentIoKey': '#{SegmentIoKey}',
    'SimplicityScriptUrl': '#{SimplicityScriptUrl}',
    'StaticAssetsBucket': '#{StaticAssetsBucket}',
    'TrustpilotApi.Host': '#{TrustpilotApi.Host}',
    'TrustpilotApi.SystemKey': '#{TrustpilotApi.SystemKey}',
    'TrustpilotInvitationsApi.Host': '#{TrustpilotInvitationsApi.Host}',
    'TrustpilotTranslationsApi.Host': '#{TrustpilotTranslationsApi.Host}',
    'VerificationDomain': '#{VerificationDomain}',
    'apps': {
        'AnalyticsApp': 'https://statistics-businessapp.#{AppDomain}/',
        'ApplicationsApp': 'https://applications-businessapp.#{AppDomain}/',
        'CategoriesApp': 'https://categories.#{AppDomain}/',
        'DashboardApp': 'https://dashboard-businessapp.#{AppDomain}/',
        'EcommscriptApp': 'https://ecommscript-businessapp.#{AppDomain}/',
        'ExternalWebhooksApp': 'https://extwebhooks-businessapp.#{AppDomain}/',
        'IntegrationsApp': 'https://integrations-businessapp.#{AppDomain}/',
        'InvitationsApp': 'https://invitations.#{AppDomain}/',
        'MarketingApp': 'https://marketing-businessapp.#{AppDomain}/',
        'productquestions-businessapp': 'https://productquestions-businessapp.#{AppDomain}/',
        'ProductReviewsApp': 'https://productreviews-businessapp.#{AppDomain}/',
        'ProductReviewsAnalyticsApp': 'https://productreviews-analyticsbusinessapp.#{AppDomain}/',
        'ProductReviewsReviewFeedApp': 'https://productreviews-reviewfeedbusinessapp.#{AppDomain}/',
        'ProfileSettingsApp': 'https://businessusers-profilebusinessapp.#{AppDomain}/',
        'SettingsApp': 'https://settings.#{AppDomain}/',
        'WidgetsApp': 'https://widgets-businessapp.#{AppDomain}/',
        'TrustboxSplitTestingApp': 'https://tboptimizerstats.#{AppDomain}/',
        'FacebookPageTabApp': 'https://facebookpagetab-businessapp.#{AppDomain}/',
        'TrustboxConfigurationApp': 'https://tboptimizersetup.#{AppDomain}/',
        'OnboardingApp': 'https://onboarding.#{AppDomain}/',
        'UpgradeBusinessApp': 'https://upgrade-businessapp.#{AppDomain}/',
        'ImageGenerator': 'https://imagegenerator-businessapp.#{AppDomain}/',
        'BusinessActivationApp': 'https://businessactivation-businessapp.#{AppDomain}/',
        'ReviewsReportsApp': 'https://businessunitcompliance-b2breviewsreports.#{AppDomain}/',
        'ServiceReviewsApp': 'https://servicereviews-businessapp.#{AppDomain}/',
        'ReviewInsightsApp': 'https://sentiment-businessapp.#{AppDomain}/',
        'LocationsApp': 'https://locations-businessapp.#{AppDomain}/',
        'WidgetsLegacyApp': 'https://widgets-legacy.#{AppDomain}/',
        'UserManagementApp': 'https://businessusers-usermanagementbusinessapp.#{AppDomain}/',
        'settings-businessapp': 'https://settings-businessapp.#{AppDomain}/',
        'BusinessUpgradesApp': 'https://businessupgrades-businessapp.#{AppDomain}/',
        'EmailWidgetsApp': 'https://emailwidgets-businessapp.#{AppDomain}/',
        'businessaccounts-businessapp': 'https://businessaccounts-businessapp.#{AppDomain}/',
        'reviewboard-businessapp': 'https://reviewboard-businessapp.#{AppDomain}/',
        'LabsApp': 'https://labs.#{AppDomain}/'
    },
    'salesforceCampaignIds': {
        'upgradeRequest': '#{salesforceCampaignIds.upgradeRequest}',
        'requestProTrial': '#{salesforceCampaignIds.requestProTrial}',
        'requestDemo': '#{salesforceCampaignIds.requestDemo}'
    },
    'httpInterceptorWhitelist': [
        'views/left-menu2.html',
        'views/top-bar2.html',
        'views/errorPage.html',
        'views/navigationActions.html',
        'modules/foundation-range-slider-angular/range-slider.html',
        'views/notifications.html',
        'views/notifications-heading.html',
        'scripts/features/announcement-modal/',
        'scripts/features/business-unit-selector-modal/',
        'views/businessapp-toggle-button.html',
        'scripts/features/upgrade-modal/',
        'views/icon-library.html',
        'scripts/components/menu-upgrade/menu-upgrade.html'
    ],
    'IntegrationsApp': {
        'EmailSignatureDomain': '#{IntegrationsApp.EmailSignatureDomain}',
        'ImageGenerator': {
            'BaseUrl': '#{IntegrationsApp.ImageGenerator.BaseUrl}',
            'BackgroundsHost': '#{IntegrationsApp.ImageGenerator.BackgroundsHost}',
        },
        'InstructionsUrl': '#{IntegrationsApp.InstructionsUrl}',
        'oldWidgetHost': '#{IntegrationsApp.oldWidgetHost}',
        'SocialSharing': {
            'FacebookAppId': '#{IntegrationsApp.SocialSharing.FacebookAppId}',
            'ReviewSharerHost': '#{IntegrationsApp.SocialSharing.ReviewSharerHost}'
        },
        'UnsplashApiHost': '#{IntegrationsApp.UnsplashApiHost}'
    },
    'OnboardingApp': {
        'defaultInvitationTemplate': '#{OnboardingApp.defaultInvitationTemplate}'
    }
};
